import { Box, Tab } from '@mui/material';
import { NameBanner, Section } from '@rumblefish/ui/Rumblefish23Theme';
import { useMemo, useState } from 'react';
import { ourServicesData, TabsValues } from './OurServices.data';
import { OurServicesItem } from './OurServices.Item';
import {
  StyledCategoryItem,
  StyledFirstTitle,
  StyledSecondTitle,
  StyledStack,
  StyledTabs,
  StyledWrapper,
} from './styles';

export const OurServices = () => {
  const [tab, setTab] = useState<TabsValues>(TabsValues.blockchain);
  const tabData = useMemo(() => {
    return ourServicesData.categories.find(
      (category) => category.value === tab
    );
  }, [tab]);

  return (
    <>
      <Section width="small">
        <Box sx={{ mt: 6 }} />
        <NameBanner text="What do we do?" type="section" />

        <StyledFirstTitle
          variant="display_sm"
          sx={{ textAlign: 'left', mt: 6, mb: 4 }}>
          Our Development Services
        </StyledFirstTitle>

        <StyledWrapper>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}>
            <StyledTabs
              value={tab}
              onChange={(_, newValue) => setTab(newValue)}
              aria-label="services tabs">
              <Tab
                label={
                  <StyledCategoryItem
                    variant="strong_400"
                    isSelected={tab === TabsValues.blockchain}>
                    Blockchain Development
                  </StyledCategoryItem>
                }
                value={TabsValues.blockchain}
              />
              <Tab
                label={
                  <StyledCategoryItem
                    variant="strong_400"
                    isSelected={tab === TabsValues.ai}>
                    AI Development
                  </StyledCategoryItem>
                }
                value={TabsValues.ai}
              />
              <Tab
                label={
                  <StyledCategoryItem
                    variant="strong_400"
                    isSelected={tab === TabsValues.software}>
                    Software Development
                  </StyledCategoryItem>
                }
                value={TabsValues.software}
              />
            </StyledTabs>
          </Box>

          <StyledSecondTitle variant="regular_500">
            {tabData?.description}
          </StyledSecondTitle>
        </StyledWrapper>

        <StyledStack>
          {tabData?.services.map((service, index) => {
            return <OurServicesItem service={service} key={index} />;
          })}
        </StyledStack>
      </Section>
    </>
  );
};
